export default {
    total: 'Total Employee',
    present: 'Check-In On Time',
    late: 'Late',
    absent: 'Absent',
    onsite: 'Onsite',
    leave: 'Leave'
}
